// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-PlmUploader-UploaderModal-UploaderModal-module__imageUploadModal--EpRop .ant-modal-body {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-components-PlmUploader-UploaderModal-UploaderModal-module__modalFooter--JRVQj {
  display: flex;
  align-items: center;
  justify-content: center;
}
.src-components-PlmUploader-UploaderModal-UploaderModal-module__finishButton--NxCwr {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/PlmUploader/UploaderModal/UploaderModal.module.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAKA;EACE,WAAA;AAHF","sourcesContent":[".imageUploadModal {\n  :global(.ant-modal-body) {\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.finishButton {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageUploadModal": `src-components-PlmUploader-UploaderModal-UploaderModal-module__imageUploadModal--EpRop`,
	"modalFooter": `src-components-PlmUploader-UploaderModal-UploaderModal-module__modalFooter--JRVQj`,
	"finishButton": `src-components-PlmUploader-UploaderModal-UploaderModal-module__finishButton--NxCwr`
};
export default ___CSS_LOADER_EXPORT___;
